import { render, staticRenderFns } from "./GUNeedCompleteEducationStatistics.vue?vue&type=template&id=288e7574&"
import script from "./GUNeedCompleteEducationStatistics.vue?vue&type=script&lang=js&"
export * from "./GUNeedCompleteEducationStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports